import { render, staticRenderFns } from "./p_loginreg.vue?vue&type=template&id=2aa4d391&scoped=true&"
import script from "./p_loginreg.vue?vue&type=script&lang=js&"
export * from "./p_loginreg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa4d391",
  null
  
)

export default component.exports